import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import clxs from 'clsx';
import Modal from "react-bootstrap/Modal";
import style from './CatalogCluezDownloadModal.module.scss';

let modalGroupIdChecked = "", catalogDlCount = 0;
let catalogDlIntervalId;

const catalogDl = (cid) => {
  if (catalogDlCount == 1) {
    return;
  }
  if (catalogDlCount == 0) {
    catalogDlCount = catalogDlCount + 1;
  }
  catalogDlIntervalId = setInterval(function () {
    try {
      var dlIframe = $('#dliframe');
      dlIframe.css({"width":"100%"});

      if (dlIframe == undefined) {
        return;
      }

      if (dlIframe.contents().find('#userInputModal').hasClass('in') == false) {
        dlIframe.contents().find('#catalog_dl_script').attr({"onclick": "dl('" + cid + "')"});
        dlIframe.contents().find('#catalog_dl_script').trigger('click').done;
        dlIframe.contents().find('#userInputModal').find('.modal-dialog.modal-lg').css({
          'margin': 0,
          'padding': 0,
          'width': '100%'
        });
        dlIframe.contents().find('#userInputModal').find('.modal-content').css({
          'border': 'none',
          'border-radius': 0,
          'box-shadow': 'none',
          'background-color': 'transparent'
        });
      }

      if (dlIframe[0] == undefined) {
        return;
      }

      if (dlIframe[0].contentWindow != undefined) {
        var ifrmDoc = dlIframe[0].contentWindow.document;
        var modalHtml = $('.modal-dialog', ifrmDoc);
        if (modalHtml.height() != dlIframe.css("height").replace(/[^0-9]/g, '')) {
          dlIframe.css({"height": modalHtml.height()});
        }
      }

      if (dlIframe.contents().find('.target-1').hasClass('jsc-dn')) {
        $("#downloadStart").remove();
      }

      if (dlIframe.contents().find('body').hasClass('jsc-loading') && !$("#downloadStart")[0]) {
        var downloadStart = $('<div/>').attr("id", "downloadStart");
        downloadStart.css({
          "z-index": "9999",
          "position": "absolute",
          "top": "0",
          "left": "0",
          "right": "0",
          "bottom": "0",
          "height": $("html").get(0).scrollHeight + "px"
        });
        $('body').append(downloadStart);
      }
    } catch (e) {
      // モーダルを閉じるタイミングでエラーが出る場合がある
      console.log("error on catalogDl()", e);
      return;
    }
  }, 400);
};

const CatalogCluezDownloadModal = (props) => {

  let {
    catalogId,
    companyId,
    requestId,
  } = props;

  let [show, setShow] = useState(false);
  let [iframeContent, setIframeContent] = useState();

  const catalogDlMain = () => {
    let domain = ''; // 環境設定
    if (document.domain.indexOf("test") > -1 || document.domain.indexOf("local") > -1) {
      domain   = 'www.test.aperza.com';
    } else if (document.domain.indexOf("stg") > -1) {
      domain   = 'www.stg.aperza.com';
    } else {
      domain   = 'www.aperza.com';
    }
    $.ajax({
      type: 'POST',
      url: "https://"+domain+"/download/catalog-dl",
      data: {"modalDlGroupNameSet": modalGroupIdChecked},
      xhrFields: {
        withCredentials: true
      },
      success: function(response) {
        setIframeContent(response);
        window.aperza.aw.catalogCluezDownloadModal = new Date().getTime();
        return;
      },
      error: function(response,bb,errorThrown){
        console.error(response.responseText);
        window.aperza.aw.catalogCluezDownloadModalError = response.responseText;
        // alert(JSON.parse(response.responseText));
        // location.reload();
      }
    });
  };

  useEffect(() => {
    catalogDlMain();

  }, []);

  useEffect(() => {
    if (companyId && catalogId && iframeContent) {
      setShow(true);
    }
  }, [requestId, catalogId, companyId]);

  useEffect(() => {
    if (show) {
      let iframe = document.getElementById("dliframe");
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.write(iframeContent);
      iframeDoc.close();
      catalogDl(companyId + '_' + catalogId);
    }
  }, [show]);

  const onModalClose = () => {
    clearInterval(catalogDlIntervalId);
    setShow(false);
    let dlIframe = $('#dliframe');
    dlIframe.remove();
    catalogDlCount = 0;
  };

  return (
    <Modal
      show={show}
      onHide={onModalClose}
      onClick={onModalClose}
      size={'lg'}
      dialogClassName={style.modal}
      id="catalogDownloadModal"
    >
      <Modal.Body className="p-0">
        <div id="modal-catalog-dl">
          <iframe id={'dliframe'}
                  className={'dliframe'}
                  style={{width:'100%', height:'0px', border:0}}
          />
        </div>
      </Modal.Body>
    </Modal>
  )

};

CatalogCluezDownloadModal.propTypes = {
  catalogId: PropTypes.number,
  companyId: PropTypes.number,
};

export default CatalogCluezDownloadModal;
